import { render, staticRenderFns } from "./ReferralsPoolProvidersModal.vue?vue&type=template&id=d8b47e0c&scoped=true"
import script from "./ReferralsPoolProvidersModal.vue?vue&type=script&lang=js"
export * from "./ReferralsPoolProvidersModal.vue?vue&type=script&lang=js"
import style0 from "./ReferralsPoolProvidersModal.vue?vue&type=style&index=0&id=d8b47e0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b47e0c",
  null
  
)

export default component.exports